export default "__VITE_ASSET__Davwp1aA__"